
import axios from "axios";


export const getSmartParcelSettingsAndCarrier = function (param_customer_uri) {
    return axios.all([
        axios.get('/WebUI/Settings/SmartParcel/SmartParcelSettings?customerUri=' + param_customer_uri),
        axios.get('/WebUI/Settings/SmartParcel/CarrierAccountData?customerUri=' + param_customer_uri),
        axios.get('/WebUI/Settings/SmartParcel/ShipEngineCarriers')
    ]).then(axios.spread(function (smartParcelSettingsOptionsResponse, carrierAccountsResponse, shipEngineCarrierResponse) {
        return {
            smartParcelSettingsOptionsResponse: smartParcelSettingsOptionsResponse.data,
            carrierAccountsResponse: carrierAccountsResponse.data,
            shipEngineCarrierResponse: shipEngineCarrierResponse.data
        };
    }));
}

export const getCarrierMarkup = function (customerId) {
    return axios.get('/WebUI/settings/smartparcel/CarrierMarkups?carrierMarkupsUri='+ '/customers/'+customerId+'/carriermarkups').then(function (response) {
        return response
    });
}

export const saveCarrierMarkup = function (param_mark) {
    return axios.post('/WebUI/settings/smartparcel/CarrierMarkups',param_mark).then(function (response) {
        return response
    });
}



export const saveSmartParcelSettings = function (param_settings_data) {
    return axios.put('/WebUI/Settings/SmartParcel/SmartParcelSettings?customerUri=' + param_settings_data.custUri, { "settings": param_settings_data.spsData }).then(function (response) {
        return response
    });
}

export const addCarrier = function (param_payload) {

    return axios.post("/WebUI/Settings/SmartParcel/CarrierAccount", param_payload).then(function (response) {
        return response
    });

}

export const deleteCarrier = function (carrierAccountUri) {

    return axios.delete("/WebUI/Settings/SmartParcel/CarrierAccount?carrierAccountUri=" + carrierAccountUri).then(function (response) {
        return response
    });

}
export const getCarrierDetail = function (shipEngoineId, customerId) {

    return axios.get("/WebUI/Settings/SmartParcel/ShipEngineSettings?seID=" + shipEngoineId + "&custId=" + customerId).then(function (response) {
        return response
    });

}
export const updateCarrier = function (carrierObj, customerId) {

    return axios.put("/WebUI/Settings/SmartParcel/ShipEngineSettings?custId=" + customerId, carrierObj).then(function (response) {
        return response
    });

}
export const migrateMarkups = function (markupUi = "/customers/carriermarkups/migrate") {
    return axios.put(`/WebUI/Settings/SmartParcel/MigrateMarkups?carrierMarkupsMigrateUri=${markupUi}`).then(function (response) {
        return response
    });
}
export const getCarrierMarkups = function (carrierMarkupUri) {

    return axios.get("/WebUI/settings/smartparcel/CarrierMarkups").then(function (response) {
        return response
    });

}

export const getProviderDetail = function (provider) {
    return axios.get("/WebUI/Settings/SmartParcel/ParcelApiMappings?provider=" + provider).then(function (response) {
        return response
    });
}
export const getCarrierAccountList = function (provider, accountNum, extraParam) {
    return axios.get("/WebUI/Settings/SmartParcel/GetCarrierAccountList?provider=" + provider + "&provideraccountid=" + accountNum + extraParam).then(function (response) {
        return response
    });
}

export const createProviderAccount = function (providerAccountObj) {
    return axios.post("/WebUI/Settings/SmartParcel/CreateProviderAccount", providerAccountObj).then(function (response) {
        return response
    }).catch(function (error) {
        return error
    });
}

export const getPackingSlipReports = function (param_payload) {
    return axios.post("/WebUI/Shipping/FindOrders/GetPackingSlipReports", param_payload).then(function (response) {
        return response
    });
}

export const getCarrierAccountSchema = function () {
    return axios.get("/WebUI/Settings/SmartParcel/GetCarrierAccountSchema").then(function (response) {
        return response;
    });
}

export const getCartonLabelTemplates = function (customerId) {
    var custId = customerId === 0 ? null : customerId;

    return axios.get('/WebUI/Shipping/SmartPack/CartonLabelTemplates?customerId=' + custId)
        .then(function (response) {
            var tempData = response.data;
            return tempData;
        });
}

export const addDynamicCarrier = function (param_payload, provider_settings, isCalledParcelApi = false) {
    let url = "/WebUI/Settings/SmartParcel/PostCarrierAccount";

    // Determine where to get listPossibleConnectionAccounts flag from based on connection type:
    let listPossibleConnectionAccountsValue = null;

    if (provider_settings) {
        // New flow: provider_settings is already the specific carrier's settings object
        if (provider_settings.settings &&
            provider_settings.settings.listPossibleConnectionAccounts &&
            provider_settings.settings.listPossibleConnectionAccounts.value) {
            listPossibleConnectionAccountsValue = provider_settings.settings.listPossibleConnectionAccounts.value;
        }
    }

    if (listPossibleConnectionAccountsValue) {
        url += "?returnCarrierList=" + listPossibleConnectionAccountsValue;
    }

    if (isCalledParcelApi) {
        url = "/WebUI/Settings/SmartParcel/PostProviderAccount";
    }

    return axios.post(url, param_payload).then(function (response) {
        return response
    });

}
export const createCarrierAccounts = function (param_payload) {
    return axios.post("/WebUI/Settings/SmartParcel/CreateCarrierAccounts", param_payload).then(function (response) {
        return response
    });

}

export const updateDynamicCarrier = function (carrierObj, hasProviderSettings) {

    return axios.put("/WebUI/Settings/SmartParcel/PutCarrierAccount?hasProviderSettings=" + hasProviderSettings, carrierObj).then(function (response) {
        return response
    });
}

export const getDynamicCarrierDetail = function (shipEngoineId, custId, hasProviderSettings) {
    return axios.get("/WebUI/Settings/SmartParcel/GetCarrierAccountSettings?carrierId=" + shipEngoineId + "&custId=" + custId + "&hasProviderSettings=" + hasProviderSettings).then(function (response) {
        return response.data;
    });
}